<!-- <h2 class="Left-15" mat-dialog-title>atencion</h2> -->
<h2 class="title"><strong>Ha ocurrido una falla..!</strong></h2>
<mat-dialog-content>
  <p>{{status}}</p>
  <p>{{error}}</p>
</mat-dialog-content>

<br/>
<mat-dialog-actions>
  <button type="button" class="btn btn-danger" (click)="Close()">Cerrar</button> 
</mat-dialog-actions>